import {
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import PopUp from "../../../containers/components/PopUp";

const useStyles = makeStyles({
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});

const ShiftTypeForm = ({ showForm, handleFormPopup }) => {
  const classes = useStyles();
  const formChildren = (
    <>
      <Stack spacing={4} paddingLeft={4} paddingRight={4} paddingBottom={2}>
        <Stack direction="row" spacing={2}>
          <TextField
            required
            fullWidth
            name="shiftname"
            type="text"
            id="outlined-required"
            label="Shift Name"
            size="small"
            className={classes.input}
            InputLabelProps={{ shrink: true }}
            // value={formValue.fromMins}
            // onChange={handleInputChange}
          />
          <TextField
            required
            fullWidth
            name="description"
            type="text"
            id="outlined-required"
            label="Description"
            size="small"
            className={classes.input}
            InputLabelProps={{ shrink: true }}
            // value={formValue.fromMins}
            // onChange={handleInputChange}
          />
        </Stack>
        <Stack direction="row" spacing={2}>
          <TextField
            required
            fullWidth
            name="shiftintime"
            type="time"
            id="outlined-required"
            label="Shift In Time"
            size="small"
            className={classes.input}
            InputLabelProps={{ shrink: true }}
            // value={formValue.fromMins}
            // onChange={handleInputChange}
          />
          <TextField
            required
            fullWidth
            name="shiftouttime"
            type="time"
            id="outlined-required"
            label="Shift Out Time"
            size="small"
            className={classes.input}
            InputLabelProps={{ shrink: true }}
            // value={formValue.fromMins}
            // onChange={handleInputChange}
          />
        </Stack>
        <Stack>
          <FormControlLabel
            control={
              <Checkbox
                defaultChecked
                sx={{ "& .MuiSvgIcon-root": { color: "#2F2A42" } }}
              />
            }
            // onChange={handleCheckBox}
            name="active"
            label="Base Fee"
            // checked={formValue?.active === "true" ? true : false}
          />
        </Stack>
        <Button
        //   disabled={!isDisabled}
        //   onClick={handleSubmit}
        //   sx={{
        //     textTransform: "none",
        //     background: !isDisabled
        //       ? "gray"
        //       : "linear-gradient(135deg, #3A416F 0%, #141727 100%)",
        //     color: "white",
        //     "&:hover": {},
        //   }}
        >
          {/* {formValue.id ? "Update" : "Ok"} */}
          OK
        </Button>
      </Stack>
    </>
  );
  return (
    <>
      <PopUp
        open={showForm}
        handleClose={handleFormPopup}
        popUpTitle="Shift Type"
        popUpChildren={formChildren}
      />
    </>
  );
};

export default ShiftTypeForm;
